import { useMemo } from 'react'
import { Button, SelectMultipleV2 } from '~/components/ui'
import {
  getMapPropertySubtypeLabel,
  getMapPropertySubtypeOptions,
} from '~/models/mapPropertyUse'

export default function MapPropertySubtypesFilter({
  propertySubtypes,
  propertyTypes,
  updateFilter,
}: {
  propertySubtypes: string[]
  propertyTypes: string[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  const groups = useMemo(
    () => getMapPropertySubtypeOptions(propertyTypes),
    [propertyTypes]
  )

  return (
    <div className="space-y-2">
      <p className="text-sm">
        Secondary Use
        {propertySubtypes.length > 0 && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter({ propertySubtypes: undefined })}>
            (reset)
          </Button>
        )}
      </p>
      <SelectMultipleV2
        isPopover={false}
        placeholder={
          groups.length === 0
            ? 'Select Primary Use to Begin...'
            : 'Select Secondary Use...'
        }
        options={groups}
        groupBy="group"
        disabled={groups.length === 0}
        value={propertySubtypes.map((value) => ({
          value,
          label: getMapPropertySubtypeLabel(value),
        }))}
        onChange={(selected) => {
          updateFilter({
            propertySubtypes: selected.map(({ value }) => value),
          })
        }}
      />
    </div>
  )
}
